<template>
	<div id="buyploy">
  		<mt-header fixed :title="$t(title)">
          	<mt-button icon="back" slot="left" onclick="window.history.go(-1)"></mt-button>
        </mt-header>
		<div class="content2">
			<div class="jygz"><span class="left">{{$t('划出金额')}}</span><span class="right" @click="allIn()">{{$t('全部划出')}}</span></div>
			<div class="hrje">
				<input type="text" name="" class="" v-model="money" :placeholder="$t('请输入转出金额')" /> <span class="name">{{coin_symbol}}</span>
			</div>
			<div class="line"></div>
			<div class="descguize">
				<div v-for="val in detail.rule">{{val}}</div>
				<div class="right">{{$t('查看规则')}}</div>
			</div>
		</div>
	    <div class="container" v-show="show_pay_pwd">
	      <div class="swiper">
	        <p class="wx_fontSize3">{{$t('请输入支付密码')}} <span class="fr" @click="closePass()"> ✕ </span></p>
	      </div>
	      <div class="passContainer">
	        <Password v-on:end="onEnd"></Password>
	      </div>
	    </div>

		<div class="send" @click="getOrder()">{{$t('发送')}}</div>
	</div>
</template>
<script>
	import { Swipe, SwipeItem, Toast} from 'mint-ui';
	import Password from "@/components/Password";
	import { httpRedeem,httpGetDetial,httpGetMywealth } from "@/api/wealth";
	export default{
  		components: { Toast, Password },
		data() {
		    return {
		    	show_pay_pwd:false,
	    		detail:{},
	    		title:'',
	    		coin_symbol:'',
	    		id:0,
		    	money:''
		    }  
	    }, 
	    activated(){
		    this.show_pay_pwd = false,
	    	this.coin_symbol = this.$route.query.coin_symbol;
	    	this.title = this.$route.query.title;
	    	this.id = this.$route.query.id;
	    	this.money = '';
			this.getDetial();
	    },
	    methods:{
			getDetial: function() {
				httpGetMywealth({id:this.id})
				.then(res => {
					this.detail = res.data.list[0];
				})
				.catch(() => {});
			},
			getOrder: function() {
				this.show_pay_pwd=true;
			},
			closePass: function() {
				this.show_pay_pwd=false;
			},
            allIn(){
            	this.money = this.detail.amount;
            },
		    onEnd: function(val) {
				httpRedeem({amount:this.money,id:this.id,password:val})
				.then(res => {
					Toast(this.$t('划出成功'));
					this.detail = res.data;
					this.show_pay_pwd=false;
					this.$router.back();
				})
				.catch(() => {});
		    },
		},
  		mounted() {}
	}
</script>
<style lang="less" scoped>
#buyploy{width:100%;height:100%;overflow: hidden;position: fixed;background:#f6f6f6;}
/*顶部*/
.header{width:100%;height:200px;position: relative;}
.mint-header{background: #ffffff;color:#212529;}
.header .bg{width:100%;height:100%;}
.content2{
    border-top: 1px solid #e3e8ed;
    margin: 40px 0 0 0;
    background-color: #fff;
	padding: 0 20px;
}
.hrje{
    height: 70px;
    input{
		line-height: 65px;
		font-size: 16px;
		width: 80%;
    }
    .name{
    	display: inline-block;
    	text-align: right;
    	line-height: 65px;
		font-size: 16px;
		width: 20%;
    };
}
.jygz .left{
	font-size: 16px;
	line-height: 44px;
	color: #212529;
	font-weight: bold;
}
.jygz .right{
	font-size: 12px;
	line-height: 44px;
	color: #1296db;
	float: right;
}
.line{
    border-top: 1px solid #e3e8ed;
}
.descguize{
	padding: 10px 0 25px 0;
	position: relative;
	color: #a9afc8;
	font-size: 12px;
	line-height: 16px;
	.left{
		width: 80%;
	};
	.right{
		position: absolute;
		width: 20%;
		line-height: 50px;
		text-align: right;
		color: #1296db;
		top:0;
		right: 0;
	}
}

.send{
	border-radius: 4px;
	text-align: center;
	font-size: 18px;
	width: 94%;
	height: 50px;
	line-height: 50px;
	background-color: #1296db;
	color: #fff;
	position: fixed;
	bottom: 3%;
	margin: 0 3%;
}

.container {
    padding: 0 2%;
    background-color: #fff;
    position: fixed;
    width: 96%;
    bottom: 0;
    height: 60%;
    z-index: 1;
    border-radius: 8px 8px 0 0;

	.swiper {
	  background-color: #fff;
	  box-sizing: border-box;
	  border-radius: 10px;
	  color: #4a4a4a;
	  padding: 10px;
	  box-sizing: border-box;
	}
	.swiper p {
	  margin: 5px;
	}
    .fr{
    	float: right;
    }
}

</style>